// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3jbKk","footer":"ModalUpdate_footer__20yne"};